import React, { useState, useEffect } from 'react';
import { getpaymentDetails } from '../../store/reducers/paymentsReducer';
import { Link } from 'react-router-dom';
import './PaymentStatus.css';
import Footer from '../Footer/Footer';
import { useDispatch, useSelector } from 'react-redux';
import { handleDownload, camelize, dateConvert } from './../../utils/Common.js';
import {checkCustomer} from '../../store/reducers/profileReducer';
import { parseMobileParamsNew, isEncrypted } from './../../utils/Common.js';   

export const PaymentStatus = () => {


    const dispatch = useDispatch();
    const { response, loading } = useSelector((state) => state.paymentsList);

    const paymentData = response?.data || {};

    useEffect(() => {
        let verifiedData;
        let regNo = JSON.parse(localStorage.getItem('reg_no'));
        let requstData = {reg_no:regNo};
        dispatch(getpaymentDetails(requstData));

        const storedMobile = localStorage.getItem('mblnbr');
        console.log("storedMobile11111",storedMobile);
        if (storedMobile && JSON.parse(storedMobile).length > 0) {
            const parsed = parseMobileParamsNew();
            console.log("parsedparsedparsed1",parsed);
            verifiedData = parsed?.verifiedData || {};
            console.log("verifiedData1", verifiedData);
            if(parsed ===  null){
                verifiedData = isEncrypted(JSON.parse(storedMobile));
            }
        }
        dispatch(checkCustomer(verifiedData));
    }, [dispatch]);

  return (
    <div className="payment-container">
        <div className="payment-success-box">
            <h2 className="success-title">Paid Successfully</h2>
            <img src="/assets/payment-success.svg" alt="Success Icon" className="success-icon" />
            <p className="amount">{paymentData?.amount || 0}</p>
            <p className='ref'>Ref No : <strong>{paymentData?.reference_id || ''}</strong></p>
            {/* <span onClick={() => handleDownload(paymentData?.certificate_path || '')} className='download'>Download Receipt</span>  */}
        </div>

        <div className="plan-details-box">
            <div className='row-1 head'>
                <div className='left'>
                    <span className='title'>Plan Details</span>
                    <div className='status-block'>
                        <p className="active">{camelize(paymentData?.status || '')}</p>
                    </div>
                </div>
                <span className='plan-name'>{paymentData?.plan_description || ''}</span>
            </div>
            <div className='row-2 head'>
                <span className='title'>Cover Validity:</span>
                <span className='plan-name'>{dateConvert(paymentData?.start_date || '')} - {dateConvert(paymentData?.expiry_date || '')}</span>
            </div>

            <div className='btn-section'>
                <button 
                    className="download-certificate-button"
                    onClick={() => handleDownload(paymentData?.certificate_path || '')}
                >
                    Download Certificate
                    <img src={`${process.env.PUBLIC_URL}/assets/certificate-download.svg`} alt="Download Certificate" className="certificate"/>
                </button>
            </div>

            <Footer />

        </div>
        <div className="order-info">
            <Link to="/my-plans" className="orders-link">Go to My Orders</Link>
        </div>
    </div>
);
};

export default PaymentStatus;
